import { z } from 'zod';
import { employeeRangeSchema } from './employeeRange.js';
export const companyProfileSchema = z.object({
    logoUrl: z.string().optional(),
    companyName: z.string(),
    description: z.string(),
    companyUid: z.string(),
    street: z.string(),
    nr: z.string(),
    city: z.string(),
    postcode: z.string(),
    website: z.string(),
    employees: employeeRangeSchema.optional(),
    smsDisabledByAccount: z.boolean(),
});
export const logoUploadResponseSchema = z.object({
    logoUrl: z.string(),
});
